import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-card',
  templateUrl: './contact-card.component.html',
  styleUrls: ['./contact-card.component.scss']
})
export class ContactCardComponent implements OnInit {
  @Input("contact") contact
  constructor() { }

  ngOnInit(): void {
    //console.log(this.contact)
  }
  display: boolean = false;

  showDialog() {
      this.display = true;
  }

}
